var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertDecisionsIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 42,
    viewBox: "0 0 25 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91677 27.25C12.218 27.25 14.0834 29.1155 14.0834 31.4167C14.0834 33.7179 12.218 35.5833 9.91677 35.5833C7.61558 35.5833 5.7501 33.7179 5.7501 31.4167C5.7501 29.1155 7.61558 27.25 9.91677 27.25ZM9.91677 27.25V12.6667M18.2501 8.5H24.5001M18.2501 12.6667H24.5001M18.2501 16.8333H24.5001M18.2501 21H24.5001M9.91677 2.25C12.218 2.25 14.0834 4.11548 14.0834 6.41667L14.0857 24.1995C16.5753 25.6407 18.2501 28.3331 18.2501 31.4167C18.2501 36.019 14.5191 39.75 9.91677 39.75C5.31439 39.75 1.58344 36.019 1.58344 31.4167C1.58344 28.3323 3.25915 25.6392 5.74985 24.1983L5.7501 6.41667C5.7501 4.11548 7.61558 2.25 9.91677 2.25Z",
    stroke: "#02E2FF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertDecisionsIcon7);
export default __webpack_public_path__ + "static/media/note-expert-decisions-icon7.8c82b96dd9feb50324e6fde5ac446c6e.svg";
export { ForwardRef as ReactComponent };